/* eslint-disable */
import { AppType } from '../utils'

export const BanmaAppBridgeHelper = {
  isFunctionReady: function (functionName) {
    return AppType.isInApp() && typeof BanmaAppBridge !== 'undefined' && typeof BanmaAppBridge[functionName] === 'function';
  },
  setTitle: function (title) {
    if(this.isFunctionReady('setTitle')){
      BanmaAppBridge.setTitle(title);
    }
  },
  exitPage: function () {
    if(this.isFunctionReady('exitPage')){
      BanmaAppBridge.exitPage();
    }
  },
  callShare: function (jsonString) {
    if(this.isFunctionReady('callShare')){
      BanmaAppBridge.callShare(jsonString);
    }
  },
  enableShare: function (jsonString) {
    if(this.isFunctionReady('enableShare')){
      BanmaAppBridge.enableShare(jsonString);
    }
  },
  disableShare: function () {
    if(this.isFunctionReady('disableShare')){
      BanmaAppBridge.disableShare();
    }
  },
  sendBroadcast: function(name, param){
    if(this.isFunctionReady('sendBroadcast')){
      if(!param) param = {};
      param.action = name;
      BanmaAppBridge.sendBroadcast(JSON.stringify(param));
    }
  },
  enableCommentFeature: function (param) {
    if(BanmaAppBridgeHelper.isFunctionReady('enableCommentFeatureV2')){//因为这个函数可能作为BanmaJSBridge.iOSAppBridgeReadyCallback的函数指针指向的值，所以不能用this.isFunctionReady。
      BanmaAppBridge.enableCommentFeatureV2(JSON.stringify(param));//为什么要用V2，因为老版本Android App里面已经实现了enableCommentFeature接口，但是没启用。
    }
  },
  disableCommentFeature: function () {
    if(this.isFunctionReady('disableCommentFeature')){
      BanmaAppBridge.disableCommentFeature();
    }
  },
  enableMenuBar: function (param) {
    if(this.isFunctionReady('enableMenuBar')){
      BanmaAppBridge.enableMenuBar(JSON.stringify(param));
    }
  },
  showAt: function (nickNameToAt) {
    if(this.isFunctionReady('showAt')){
      BanmaAppBridge.showAt(nickNameToAt);
    }
  },
  setAt: function (nickNameToAt) {
    if(this.isFunctionReady('setAt')){
      BanmaAppBridge.setAt(nickNameToAt);
    }
  },
  goLogin: function () {
    if(this.isFunctionReady('goLogin')){
      BanmaAppBridge.goLogin();
    }
  },
  openBrowser: function (link) {
    if(this.isFunctionReady('openBrowser')){
      BanmaAppBridge.openBrowser(link);
    }
  },
  goContact: function (phoneNumber) {
    if(this.isFunctionReady('goContact')){
      BanmaAppBridge.goContact(phoneNumber);
    }
  },
  showShotBar: function () {
    if(this.isFunctionReady('showShotBar')){
      BanmaAppBridge.showShotBar();
    }
  },
  viewImages: function (jsonString) {
    if(this.isFunctionReady('viewImages')){
      BanmaAppBridge.viewImages(jsonString);
    }
  },
  enablePCHintButton: function () {
    if(this.isFunctionReady('enablePCHintButton')){
      BanmaAppBridge.enablePCHintButton();
    }
  },
  getUserInfoFromNative: function (callback) {//在App 2.6版本中提供
    if(this.isFunctionReady('getUserInfoFromNative')){
      if(AppType.isInAndroid()){//Android里是直接返回值
        callback(BanmaAppBridge.getUserInfoFromNative());
      }else{//iOS里是通过回调返回值
        BanmaAppBridge.getUserInfoFromNative(callback);
      }
    }else{
      callback({});
    }
  },
  getSystemInfoFromNative: function (callback) {//在App 2.6版本中提供
    if(this.isFunctionReady('getSystemInfoFromNative')){
      if(AppType.isInAndroid()){//Android里是直接返回值
        callback(BanmaAppBridge.getSystemInfoFromNative());
      }else{//iOS里是通过回调返回值
        BanmaAppBridge.getSystemInfoFromNative(callback);
      }
    }else{
      callback({});
    }
  },
  trackEvent: function (eventId, label, mapKv) {
    if(this.isFunctionReady('trackEvent')){
      BanmaAppBridge.trackEvent(JSON.stringify({eventId:eventId, label:label, mapKv:mapKv}));
    }
  },
  trackPageBegin: function (pageName) {
    if(this.isFunctionReady('trackPageBegin')){
      BanmaAppBridge.trackPageBegin(pageName);
    }
  },
  trackPageEnd: function (pageName) {
    if(this.isFunctionReady('trackPageEnd')){
      BanmaAppBridge.trackPageEnd(pageName);
    }
  },
  getDeviceId: function (callback) {
    if(this.isFunctionReady('getDeviceId')){
      if(AppType.isInAndroid()){//Android里是直接返回值
        callback(BanmaAppBridge.getDeviceId());
      }else{//iOS里是通过回调返回值
        BanmaAppBridge.getDeviceId(callback);
      }
    }else{
      callback({});
    }
  },
  trackPageOn: function (pageName) {
    if(this.isFunctionReady('trackPageOn')){
      BanmaAppBridge.trackPageOn(pageName);
    }
  },
  payOrderId: function (orderId) {
    if(AppType.isInAndroid() && this.isFunctionReady('CreateLiveBroadcastOrder')){
      BanmaAppBridge.CreateLiveBroadcastOrder(orderId);
    } else if(this.isFunctionReady('createLiveBroadcastOrder')) {
      BanmaAppBridge.createLiveBroadcastOrder(orderId);
    }
  },
  techStatsPayOrderId: function (orderId) {
    if(this.isFunctionReady('createTechStatsOrder')) {
      BanmaAppBridge.createTechStatsOrder(orderId);
    }
  },
  goWeappPage: function(param){
    if(this.isFunctionReady('goWeappPage')){
      BanmaAppBridge.goWeappPage(JSON.stringify(param));
    }
  },
};
